import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { EVENT } from "@/data/eventData";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = () => {
    const target = new Date(EVENT.openingCeremonyISO).getTime();
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const tick = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(tick);
    }, []);

    const diff = Math.max(0, target - now);
    const units = [
        { value: Math.floor(diff / 86400000), label: "Days" },
        { value: Math.floor((diff % 86400000) / 3600000), label: "Hours" },
        { value: Math.floor((diff % 3600000) / 60000), label: "Minutes" },
        { value: Math.floor((diff % 60000) / 1000), label: "Seconds" },
    ];

    return (
        <section
            data-testid="countdown-section"
            className="border-b border-cream/5 bg-coal/40 py-14 md:py-20"
        >
            <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-5 md:flex-row md:items-end md:justify-between md:px-10">
                <Reveal>
                    <div className="flex items-center gap-4">
                        <span className="h-px w-10 bg-crimson" aria-hidden="true" />
                        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.4em] text-scarlet">
                            The Gavel Falls In
                        </p>
                    </div>
                    <p className="mt-5 max-w-sm font-serif text-2xl font-light italic leading-snug text-cream md:text-3xl">
                        Opening Ceremony · {EVENT.openingDate} · BHU
                    </p>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="flex items-start gap-3 sm:gap-8 md:gap-10" role="timer" aria-label="Countdown to the opening ceremony">
                        {units.map((unit, i) => (
                            <div key={unit.label} className="flex items-start gap-3 sm:gap-8 md:gap-10">
                                <div data-testid={`countdown-${unit.label.toLowerCase()}`}>
                                    <p className="font-serif text-4xl font-light tabular-nums leading-none tracking-tight text-cream sm:text-5xl md:text-7xl">
                                        {pad(unit.value)}
                                    </p>
                                    <p className="mt-3 font-sans text-[9px] font-semibold uppercase tracking-[0.35em] text-ash md:text-[10px]">
                                        {unit.label}
                                    </p>
                                </div>
                                {i < units.length - 1 && (
                                    <span aria-hidden="true" className="pt-0.5 font-serif text-3xl font-light text-crimson/70 md:text-6xl">
                                        :
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Countdown;
